/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-03 16:47:37
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-08 15:13:57
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/TermsAndConditionEditor/tools.ts
 */

import _ from 'lodash';
import { generateErrorKey, timeoutScroll as scroll } from 'src/tools/helper';
import { EnumCollapseId } from './slice';
import { changedStatus } from 'src/tools/constant';
import { reduxUpdatedStatusControl } from 'src/tools/helper';

const pageSettingValidation = (pageSetting) => {
  const _pageSetting = _.cloneDeep(pageSetting || {});
  const { isNameDuplicate, name, nameIsValid } = _pageSetting;
  let flag = false;
  if (!name) {
    _pageSetting[generateErrorKey('name')] = true;
    flag = true;
  }
  if (!nameIsValid) {
    _pageSetting[generateErrorKey('nameIsValid')] = true;
    flag = true;
  }
  if (isNameDuplicate) {
    _pageSetting[generateErrorKey('isNameDuplicate')] = true;
    flag = true;
  }
  return { hasError: flag, data: _pageSetting };
};

const contentValidation = (content) => {
  const _content = _.cloneDeep(content || {});
  const { isEmpty } = _content;
  let flag = false;
  if (isEmpty) {
    _content[generateErrorKey('content')] = true;
    flag = true;
  }
  return { hasError: flag, data: _content };
};

const validation = (state, isPrimary) => {
  const { pageSetting, content } = state || {};

  const { hasError: pageSettingHasError, data: _pageSetting } =
    pageSettingValidation(pageSetting);
  if (pageSettingHasError) {
    state.collapseOpen[EnumCollapseId.PageSetting] = true;
    state.pageSetting = _pageSetting;
    state.timeoutRef.push(
      scroll('SalesChannelLegalTermsAndConditionEditorPageName'),
    );
    return false;
  }

  const { hasError: contentHasError, data: _contentSetting } =
    contentValidation(content);
  if (contentHasError) {
    state.collapseOpen[EnumCollapseId.Content] = true;
    state.content = _contentSetting;
    state.timeoutRef.push(
      scroll('SalesChannelLegalPageTermsAndConditionEditorContent'),
    );
    return false;
  }

  return true;
};

const convertDataFromReduxToServer = (state) => {
  const {
    pageSetting,
    legalSetting,
    content: contentSetting,
    uuid,
    salesChannelUuid,
    storeUuid,
  } = state;
  const { name, remarks } = pageSetting;

  const { setAgreementAsRequired, defaultStatusChecked } = legalSetting;
  const { content } = contentSetting;

  return {
    name,
    remarks,
    uuid,
    salesChannelUuid,
    storeUuid,
    content,
    setAgreementAsRequired,
    defaultStatusChecked,
  };
};

const convertDataFromServerToRedux = (data) => {
  const {
    name,
    remarks,
    uuid,
    salesChannelUuid,
    storeUuid,
    content: _content,
    setAgreementAsRequired,
    defaultStatusChecked,
    salesChannelName,
  } = data || {};

  const pageSetting = { name, remarks, nameIsValid: true };
  const legalSetting = {
    setAgreementAsRequired,
    defaultStatusChecked,
  };
  const content = { content: _content };

  return {
    pageSetting,
    legalSetting,
    content,
    uuid,
    salesChannelUuid,
    salesChannelName,
    storeUuid,
    ...changedStatus,
    ...reduxUpdatedStatusControl,
  };
};

export {
  validation,
  convertDataFromReduxToServer,
  convertDataFromServerToRedux,
};
